var _circle, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCountBg(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 53,
    height: 53,
    viewBox: "0 0 53 53",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 26.5,
    cy: 26.5,
    r: 25,
    fill: "white",
    stroke: "url(#paint0_linear_191_5614)",
    strokeWidth: 3
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_191_5614",
    x1: 69.5625,
    y1: 53,
    x2: -22.7143,
    y2: -18.9286,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#2A73DE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#AEDBFF"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCountBg);
export default __webpack_public_path__ + "static/media/count-bg.aea365bbe68afc7ac6833198a0ba1910.svg";
export { ForwardRef as ReactComponent };